import { FC, useMemo } from 'react';

import { Grid, Typography } from '@mui/material';

import { IRadioOptionType } from 'interfaces/forms';

import { BottomSlider } from 'components/_basic/BottomSlider';
import { RadioGroup } from 'components/_basic/RadioGroup';
import { CopyLinkButton } from 'components/CopyLinkButton/CopyLinkButton';
import { ShareLinksForm } from 'components/ShareLinksForm/ShareLinksForm';

import { IManageShareOnePageProps } from '../type';

import styles from './ManageShareMobile.module.scss';

interface IProps extends IManageShareOnePageProps {
  isOpened: boolean;
  onClose: VoidFunction;
}

export const ManageShareMobile: FC<IProps> = ({
  isOpened,
  onClose,
  onCopyLinkClick,
  isLinkCopied,
  dropdownOptions,
  dropdownValue,
  onDropdownChange,
  isRestricted,
  formButtonText,
  formLabel,
  formError,
  register,
  isFormButtonDisabled,
  onFormSubmit,
  isRequestPending
}) => {
  const getRadioOptions = useMemo(
    (): IRadioOptionType[] =>
      dropdownOptions.map(({ value, title, text }) => ({
        label: (
          <>
            <Typography variant="body2" marginBottom="2px">
              {title}
            </Typography>
            <Typography variant="subtitle2">{text}</Typography>
          </>
        ),
        value,
      })),
    [],
  );

  return (
    <BottomSlider isOpened={isOpened} onClose={onClose}>
      <Grid container gap="16px">
        <Grid item className={styles.header}>
          <Typography component="h3" variant="h5">
            Share project
          </Typography>
          <CopyLinkButton onClick={onCopyLinkClick} isLinkCopied={isLinkCopied} disabled={isRestricted} />
        </Grid>
        <Grid item xs={12}>

          {/* TODO add the loader */}
          <RadioGroup value={dropdownValue} onChange={onDropdownChange} options={getRadioOptions} />
        
        </Grid>
        {!isRestricted && (
          <Grid item xs={12}>
            <ShareLinksForm
              buttonText={formButtonText}
              label={formLabel}
              register={register}
              error={formError}
              isButtonDisabled={isFormButtonDisabled}
              onSubmit={onFormSubmit}
              isLoading={isRequestPending}
            />
          </Grid>
        )}
      </Grid>
    </BottomSlider>
  );
};
